<template>
  <div :id="`${type}-google-button`" />
</template>


<script>
  import loadScript from 'simple-load-script';

  import errorHandlers from '@/services/error-handlers';

  import returnAppConfig from '@/helpers/return-app-config';

  import signInWithThirdPartyMixin from '@/mixins/sign-in-with-third-party';


  export default {
    name: 'CfGoogleSignIn',

    mixins: [signInWithThirdPartyMixin],

    props: {
      type: {
        type: String,
        required: true
      }
    },

    mounted() {
      this.onComponentMounted();
    },

    methods: {
      async onComponentMounted() {
        try {
          await this.loadGoogleIdentityServiceSDK();

          this.initializeSignInButton();
        }
        catch (error) {
          errorHandlers.silent(error);
        }
      },

      async loadGoogleIdentityServiceSDK() {
        if (!window.google?.accounts) await loadScript('https://accounts.google.com/gsi/client');
      },

      initializeSignInButton() {
        // https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.initialize
        window.google.accounts.id.initialize({
          client_id: returnAppConfig().googleApiClientId,
          callback: this.signInSuccessHandler
        });

        // https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.renderButton
        window.google.accounts.id.renderButton(
          document.getElementById(`${this.type}-google-button`),
          { width: '400px', shape: 'pill', text: 'continue_with' }
        );
      },

      signInSuccessHandler({ credential }) {
        this.signInWithThirdPartyToken({
          credentials: {
            code: credential,
            type: 'Google'
          }
        });

        // this.$triggerGoogleTrackingEvent('CreateAccountSuccess', 'Account');

        this.$triggerNewRelicEvent('CreateAccountWithGoogle', 'Information', 'Create Account With Google');
      }
    }
  };
</script>
